// export const formatTime = (time) => {
//     let totalSeconds = 0;

//     if (typeof time === "string") {
//       // Handle "HH:MM:SS" format
//       const parts = time.split(":");
//       if (parts.length === 3) {
//         const hours = parseInt(parts[0], 10) || 0;
//         const minutes = parseInt(parts[1], 10) || 0;
//         const seconds = parseInt(parts[2], 10) || 0;
//         totalSeconds = hours * 3600 + minutes * 60 + seconds;
//       }
//     } else if (typeof time === "number") {
//       // Assume time is total seconds
//       totalSeconds = time;
//     }

//     // Calculate total minutes, rounding up to nearest minute
//     const totalMinutes = Math.ceil(totalSeconds / 60);
//     const hours = Math.floor(totalMinutes / 60);
//     const minutes = totalMinutes % 60;

//     // Format the result
//     return hours > 0
//       ? `${hours}h ${minutes > 0 ? `${minutes}m` : ""}`
//       : `${minutes}m`;
//   };


export const formatTime = (time) => {
  let totalSeconds = 0;
  
  if (typeof time === "string") {
    // Check if the time format includes days (D.HH:MM:SS)
    if (time.includes(".")) {
      const [days, timepart] = time.split(".");
      const parts = timepart.split(":");
      
      if (parts.length === 3) {
        const daysValue = parseInt(days, 10) || 0;
        const hours = parseInt(parts[0], 10) || 0;
        const minutes = parseInt(parts[1], 10) || 0;
        const seconds = parseInt(parts[2], 10) || 0;
        
        totalSeconds = (daysValue * 24 * 3600) + (hours * 3600) + (minutes * 60) + seconds;
      }
    } else {
      // Handle standard "HH:MM:SS" format
      const parts = time.split(":");
      if (parts.length === 3) {
        const hours = parseInt(parts[0], 10) || 0;
        const minutes = parseInt(parts[1], 10) || 0;
        const seconds = parseInt(parts[2], 10) || 0;
        
        totalSeconds = hours * 3600 + minutes * 60 + seconds;
      }
    }
  } else if (typeof time === "number") {
    // Assume time is total seconds
    totalSeconds = time;
  }

  // Calculate days, hours, minutes
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.ceil((totalSeconds % 3600) / 60); // Rounding up minutes
  
  // Format the result
  if (days > 0) {
    return `${days}d ${hours > 0 || minutes > 0 ? `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}` : ''}`;
  } else if (hours > 0) {
    return `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`;
  } else {
    return `${minutes}m`;
  }
};